export default {
  /**邀请返佣首页 start */
  inviToReback: "お友達紹介",
  accumuRewrds: "累積報酬を受け取りました",
  completedTranscation:
    "フレンドが1件以上の無期限契約取引を完了すると、10USDTの報酬が追加されます",
  inviteQuick: "人材を求めております。早速行動しましょう～",
  currWeekRank: "今週のランキング",
  weekRank: "ランキングリスト",
  inviteNum: "招待人数",
  rebackAmount: "リベート額",
  checkAllRanks: "一覧を表示する",
  rebackRegu: "報酬ルール",
  rebaRegu1:
    "フレンドが初めてチャージした後、あなたは60日内に取引25％の手数料還元を獲得できます。ご注意：1人のフレンドにつき、500USDTまで還元されます。招待人数が多いほど多く還元されます。上限はありません。",
  rebaRegu2:
    "ダブル報酬：フレンドが1件のBTC無期限契約の取引を行えば、あなたは10USDTの追加報酬を獲得できます。",
  shareOnce: "ワンクリックで共有",
  myBill: "マイポスター",
  shareToFace: "QR code",
  myShareQrCode: "マイQR招待コード",
  sharOnceTitle: "フレンド{phone}があなたを招待しています",
  sharOnceText: "BTCC登録で5USDT報酬獲得イベントをご招待しています",
  shareActiveRegu: "イベントルール",
  shareActiveTime:
    "キャンペーン期間：常時開催 キャンペーン対象：実際のユーザー;",
  shareActiveSpire: "ボーナス計算の有効期限：アクティベートされた60日以内;",
  shareActiveReward:
    "取引リベート：ボーナス計算の有効期間中、被招待者が口座を開設して取引をアクティベートすると、招待者は対応する取引のUSDTリベートを獲得できます;",
  shareActiveTip:
    "注：友だちの招待、取引のリベートの上限は1人につき500USDTです。紹介すればするほど獲得できます。上限はありません。",
  shareActiveAtten: "注意事項：",
  shareAtiveRegu1:
    "被招待者は、招待者の専用招待リンク（または2次元コード）を通じて口座を開設する必要があります。そうでなければ、有効な招待と見なされず、招待リベートを受け取ることができなくなります。リアルユーザーだけが専用招待リンク（または2次元コード）を生成することができます;",
  shareAtiveRegu2:
    "取引枚数の計算：被招待者のアクティベート後、60日以内のすべての決済枚数;",
  shareAtiveRegu3:
    "リベートボーナスは平日（月曜日～金曜日）に配分されます。ただし、休日、祝日による延期がございます;",
  shareAtiveRegu4:
    "弊社の他のキャンペーン、イベントが開催の場合、他のキャンペーン、イベントの規約が優先されます;",
  shareAtiveRegu5:
    "BTCCは本条項の最終解釈権、および本優待を事前に通知することなく随時修正または終了する権利を留保します。",
  /**邀请返佣首页 end */
  /**邀请记录，返佣记录 start */

  inviteReocrd: "招待記録",
  rebackRecord: "還元記録",
  invitedAccount: "招待人の口座",
  inviteTime: "招待時間",
  status: "ステータス",
  checkMore: "もっと",
  noRecord: "記録はありません！",
  type: "タイプ",
  rebaNum: "還元数",
  activited: "有効",
  notActive: "無効",
  /**邀请记录，返佣记录 end */
  /**排行榜 start */

  rankList: "ランキング",
  yourCurrWeekData: "、あなたの今週のデータ",
  billboard: "ランキング",
  phone: "携帯電話番号",
  cumulateReback: "累計還元",
  noData: "データはありません",
  /**排行榜 end */
  /**账户等级 start */

  account: "口座",
  accountLevel: "現在のアカウントレベル",
  miniAccount: "ミニ口座",
  stdAccount: "スタンダード口座",
  vipAccount: "VIP口座",
  stdFeeCut: "手数料6.66％オフ",
  vipFeeCut: "手数料20％オフ",
  currYouAre: "現在の口座",
  min: "ミニ口座",
  std: "スタンダード口座",
  dia: "VIP口座",
  superValueReco: "より多くの特典が！",
  invest: "入金（日本円から{unit}を購入）",
  upgradeQuick: "今すぐアップグレード",
  moreGradeProfit:
    "今後、より多くの口座レベルの特典が開設される予定ですので、是非ともご期待ください",
  konwAccountLevel: "口座レベルについて",
  whatsAccountLevel: "口座レベルとは？",
  thisIsAccountLevel:
    "累積入金額がグレードアップの基準に到達していれば、カスタマーサービスに連絡しグレードアップのご希望をお伝えください。金額が多いほどより多くの割引を楽しめるので、ぜひグレードアップし、より多くの特典をゲットしましょう。    ",
  whichAccountLevel: "口座レベルにはどんな種類があるのか？",
  accountLevelTypes:
    "BTCCアカウントはミニ、スタンダード、VIPの3種類があります。累積入金額に応じてアカウントをレベルアップすることができます。",
  accountLevCondiAndProfit: "グレードアップの条件と特典",
  feeRate: "手数料",
  level: "レベル",
  deposit: "累積入金額",
  profit: "特典",
  mini: "ミニ",
  noRights: "特権なし",
  standard: "スタンダード",
  stdFeeCuts: "手数料6.66％オフ",
  vipFeeCuts: "手数料20％オフ",
  moreCutToFees: "実際の手数料割引は手数料ページにご参照ください。",
  example: "例",
  exampleDetail:
    "BTC/USDTの無期限契約を50枚を取引し、市場価格が8000USDTになって決済された場合",
  noRecharge: "（特典なし）",
  cut40: "(40USDTオフ)",
  cut120: "(120USDTオフ)",
  minGradeAtten:
    "今すぐレベルアップすれば、よる多くの特典をご利用いただけます！",
  stdGradeAtten:
    "今すぐレベルアップすれば、よる多くの特典をご利用いただけます！",
  diaGradeAtten:
    "今すぐレベルアップすれば、よる多くの特典をご利用いただけます！",
  /**账户等级 end */
  /**账户升级start */

  appliUpgrade: "口座グレードアップの申し込み",
  accountNumber: "口座番号",
  upgradeTo: "次のレベルにグレードアップ",
  submit: "申し込む",
  upgradeNeedKnow: "グレードアップの注意事項：",
  upgradeNeedKnow1:
    "1.グレードアップを申し込む前に、口座にポジションや予約注文がないことをご確認ください。",
  upgradeNeedKnow2:
    "2.申請を受け取った翌営業日の午前中に書類を行っております。",
  upgradeNeedKnow3:
    "3.グレードアップ申請が承認したら、再度ログインをしていただければアップしたグレードが反映されます。",
  accountUpgrade: "口座レベルアップ",
  applyPno: "申込送信完了！ （申込番号：{pno}）",
  applyNumber: "お客様のBTCC口座番号：",
  applyFrom: "口座を（）から",
  applyTo: "にレベルアップ：",
  applyResTime:
    "申し込み送信後の翌営業日の正午までに、カスタマーサービスはお問い合わせの件を審査、処理します。",
  /**账户升级end */

  accountNoDot: "口座",
  bonus: "キャッシュバック",
  cashBack: "リベート",

  // 邀请返佣
  inviteHasInvitedUser: "招待済みユーザー",
  inviteCumulativeBack: "累計リベート（USDT）",
  inviteFriend: "友達に紹介する",
  inviteFriendDesc:
    "一緒にBTCCに登録し、毎日もらえるボーナスをゲットしましょう。BTCC特典センターは最大1BTCが獲得できます。紹介コードを記入して登録してください。",
  inviteMyInviteLink: "紹介専用リンク",
  inviteShareLink: "コピー",
  inviteCode: "招待コード：",
  inviteCopy: "コピー",
  inviteNow: "今すぐ紹介",
  inviteToUser: "紹介されたユーザー",
  inviteMyReward: "マイリベート",
  inviteUser: "ユーザー",
  inviteRegisterTime: "登録日時",
  inviteNoInvitePerson: "招待された人はいません",
  inviteStartInvite: "招待を始める",
  inviteReward: "リベート（USDT）",
  inviteQRDesc:
    "BTCCに登録すると、最高 500USDTのキャッシュバックを受け取れます",
  inviteQRJoin: "スキャンして会員登録",
  inviteCopySuccess: "コピーが完了しました",
  inviteCopyError: "コピーに失敗しました",
  inviteFriendWin: "お友達紹介し",
  inviteWinPercent: "25%",
  inviteBack: "のリベートを獲得しよう",
  inviteNoRecord: "記録はありません",
  inviteSlogan:
    "お友達に口座開設と取引を招待し、最大<strong>500USDT</strong>を獲得！",

  "您当前VIP等级,享受手续费折扣":
    "現在のVIPグレード：<span class='{level}'></span>アップグレードして <strong>{current}</strong> の手数料割引を楽しもう",
  VIP交易费率: "VIPの取引手数料",
  VIP等级: "VIPグレード",
  账户资金: "口座残高",
  币币交易手续费: "コイン交換手数料",
  合约交易手续费: "契約取引手数料",
  前往充值: "今すぐグレードアップ",
  前往充币: "今すぐ入金",
  充提币手续费: "お預入・ご送付手数料",
  币种: "仮想通貨",
  充币费用: "預入手数料",
  提币费用: "送付手数料",
  最小提币数量: "最低送付額",
  最小充币数量: "最低預入額",
  折扣: "{amount} オフ",
  说明: "説明：",
  说明1:
    "BTCC VIPプログラムのVIPレベルは、記載されている条件に従って、自動的にグレードアップが行われます。以下、VIPレベル変更時間についてご案内します。",
  说明2:
    "新しいVIP料金プログラムでグレードアップされたら、グレードダウンされることはありません。",
  说明3: "各ポジション建てとポジション決済の取引手数料は、ユーザーの現在のVIPレベルに応じて発生します。",
  说明4: "BTCCの取引手数料ではTaker(テイカー)とMaker（メイカー）を区別しません。",
  说明5: "上記は、2023年1月10日16：00（日本時間）より有効となりますので、ご注意ください。",
  vip权益全面升级: "口座特典パワーアップ",
  生效时间: "2022/04/25 00:00:00 (UTC+8)から有効",
  其他货币: "その他のコイン",

  // 累计充值活动
  新手专享: "新規ユーザ限定",
  新手专享豪礼送: "新規ユーザ限定豪華ボーナス",
  注册成功后等级赠金奖励:
    "口座開設後の{day}日以内に入金の条件をクリアし、ボーナスを獲得しましょう。",
  立即报名: "ログインして参加",
  如何领取奖励: "ボーナスの獲得方法",
  如何领取奖励第一步: "1. 口座開設",
  如何领取奖励第二步: "2. 入金の条件をクリア",
  如何领取奖励第三步: "3. ボーナスは、キャンペーン期間終了後に自動的に付与される",
  立即买币: "すぐにコインを<br />購入する",
  立即充币: "すぐにコインを<br />預け入れる",
  储值福利进度: "入金ボーナスプログレス({coin}入金)",
  充值升级提示:
    "口座開設後の{day}日以内に多くの入金を行いましょう。キャンペーン期間内で最高17,500USDTのボーナスを獲得することが可能です。",
  活动举例: "ボーナス獲得の例",
  有效充值: "入金",
  累计返利: "累計ボーナス(USDT) ",
  活动规则及条款: "キャンペーン詳細・ルール",
  活动版权: "BTCCは全ての規約に関する最終解釈権を留保します。",
  请联系客服:
    "ご不明な点がある場合カスタマーサポートまでご連絡するようお願い申し上げます。",
  报名成功: "申し込みが完了しました ",
  充币提示:
    "以下よりお気に入りの仮想通貨を選び、入金を始めましょう。仮想通貨の種類を選択すると、該当の仮想通貨の入金プログレスを確認することが可能です。",
  我已了解: "わかりました",
  充值升级下一级:
    "<strong>{bonus}</strong>ボーナスを獲得しました。<br />さらに累計で<strong>{amount}</strong>ボーナスを入金し<br />次のレベルのボーナスを獲得しましょう！",
  不符合新手报名条件: "恐れ入りますが、本キャンペーンを利用することができなくなりました。",
  前往福利中心参与其他活动:
    "【キャンペーン】ページのほかのキャンペーンをご利用ください。",

  我的赠金记录: "ボーナス記録",
  福利中心: "無料ボーナス",
  立即登录: "今すぐログインする",
  免费注册: "無料で登録する",
  "参与活动": "キャンペーンに参加する",
  "立即参与": "今すぐ参加する",
  "继续充值": "さらに入金してボーナスゲット",
  captcha_desc: "右にドラッグ",
  当前等级: "現在のグレード:",
  当前: "",
  参数: "/",
  兑换手续费减免: "コイン交換割引率",
  提币手续费减免: "出金割引率",
  月总成交量USD: "過去30日の取引高 (ドル)",
  账户资产USD: "アカウント資産 (ドル)",
  账户资产: "アカウント資産",
  继续升级: "グレードアップして{amount}の割引を楽しもう",
  gotIt: "了解した",
  我的30日成交量: "過去30日取引高",
  最近30天成交的交易合约: "過去30日間の先物取引の取引高を算出し、USDで表示しています。",
  我的资产: "口座総資産",
  昨日账户资产: "すべての仮想通貨を含む口座の総資産を算出※し、USDで表示しています。<span>※毎日の日本時間1時に更新</span>",
  "title": "10日の取引チャレンジ",
  "solgen": "チャレンジをクリアにしてミステリーボックスを獲得しよう！最大210USDTボーナスと取引手数料を無料にすることができます。",
  "super": "スーパーミステリーボックス",
  "super_award": "ランダムに{min}から{max}USDTを獲得",
  "supper_task": "7つのミステリーボックスを集めて獲得",
  "supper_tip": "先にデイリーチャレンジを完成して7つのミステリーボックスを獲得しましょう",
  "supper_open": "開く",
  "day": "プログレス：{day}｝日目",
  "award_fee": "ランダム取引手数料キャッシュバック率 {min}-{max}%",
  "award_bouns": "{min}-{max} USDTのボーナス",
  "task_complete": "<span>{reach}/{total}</span>の取引を完了した",
  "contract_task": "取引チャレンジ",
  "task_need": "<span>{num}</span>取引を完了する",
  "get_award_fee": "{amount}%の手数料キャッシュバックを獲得しました",
  "get_award_bouns": "{amount}USDTのボーナスを獲得しました",
  "award_overdue": "期限切れ",
  "award_hasget": "獲得済み",
  "award_toget": "開封待ち",
  "task_nostart": "現在利用不可",
  "task_ongoing": "進行中",
  "task_rules": "キャンペーン詳細",
  "task_rules_content1": "1. 参加条件：本キャンペーンは 2022年12月23日 11:00:00 (日本時間) にVIP0のユーザーのみご利用いただけます。本キャンペーン後にVIP1にレベルアップすると、自動的に本キャンペーンに登録されます。",
  "task_rules_content1_desc": "2022年12月23日 11:00:00 (日本時間) にすでにVIP1～9になったユーザーはご利用いただけません。",
  "task_rules_content2": "2. ユーザーがVIP1になったら、キャンペーンは開始されます。本キャンペーンページの情報は、毎日06:00（日本時間）でアップデートされます。",
  "task_rules_content3": "3. 当日のミステリーボックスを開くためには、当日の取引チャレンジを完了する必要があります。ユーザーが毎日06:00（日本時間）でその日のチャレンジを完了しなかった場合ミステリーボックスは期限切れとなります。取引回数は決済時間後に自動的にリセットされ、翌日の取引チャレンジも自動的に利用できるようになります。",
  "task_rules_content4": "4. ミステリーボックスの内容は、取引手数料キャッシュバックとボーナスの2種類です。取引手数料のキャッシュバック：取引や出金が可能で、ミステリーボックスが開封されると自動的にユーザーのアカウントに付与されます。ボーナス：取引手数料をカバーするためにのみ使用可能です。カバー率はユーザーのVIPレベルによって異なります。",
  "task_rules_content5": "5. 取引手数料のキャッシュバックは、その日の取引チャレンジに完了する取引数に対してのみ算出されます。その日の取引チャレンジを超えた取引数は、キャッシュバックの対象にはなりません。",
  "task_rules_content6": "6. スーパーミステリーボックスを獲得するためには、ユーザーは任意の7日間の取引チャレンジを完了し、ミステリーボックスを7個開封する必要があります。そうでない場合はスーパーミステリーボックスを開封することはできません。",
  "task_rules_content7": "7. ミステリーボックスの内容は、ランダムで付与されます。",
  "task_rules_content8": "8.ミステリーボックスの内容は開封後にリアルタイムで口座に反映されます。 反映されない場合は、後でもう一度試してみるか、カスタマーサービスに連絡して確認してください。",
  "task_rules_content9": "9. キャンペーン期間中に異常な行動などにより、アカウントが制限された場合、ミステリーボックスの開封対象外となります。",
  "task_rules_content10": "10. 取引回数は、USDT先物取引、インバース先物取引のポジションの建玉、決済と強制決済が含まれます。",
  "task_rules_content11": "キャンペーン利用規約",
  "task_rules_content12": "1. キャンペーン期間中に複数アカウントの作成、チームワークによる不正登録、取引高の水増し、市場操作ど、その他の不正行為が行われたと判断した場合、悪徳行為と見なされ、BTCCは関連アカウントの参加資格を無効にする権利を有します。",
  "task_rules_content13": "2. 本キャンペーンとその規則と条件を随時改訂、一時停止、終了する権利を有します。",
  "task_rules_content14": "3. BTCCは、本キャンペーンを解釈の権利を留保します。ご不明な点がございましたら、弊社カスタマーサービスまでお問い合わせください。",
  "complete_task": "<span>{num}</span>個取引を完了した",
  "no_standard": "チャレンジはまだ完了していませんー現在{num}個完了しました"
};



// WEBPACK FOOTER //
// ./src/locales/ja-JP.js